import {
	useBranchMenuGroupCreateMutation,
	useBranchMenuGroupDeleteMutation,
	useBranchMenuGroupUpdateMutation,
} from "@/generated/graphql";

export interface MenuGroupBindCreateInput {
	branchID: string;
	branchCode: string;
	branchName: string;
	salesChannelID: string;
	salesChannelCategoryGroupID: string;
	salesChannelCategoryGroupName: string;
}

export interface MenuGroupBindUpdateInput extends MenuGroupBindCreateInput {
	branchSalesChannelCategoryGroupID: string;
}

export const useBranchMenuGroupMutations = () => {
	const [, create] = useBranchMenuGroupCreateMutation();
	const [, update] = useBranchMenuGroupUpdateMutation();
	const [, del] = useBranchMenuGroupDeleteMutation();

	return {
		create: (input: MenuGroupBindCreateInput) => create({ input }),
		update: (input: MenuGroupBindUpdateInput) => update({ input }),
		remove: (id: string) => del({ id }),
	};
};
